export default __webpack_public_path__ + "static/media/element_14.1682503c.jpg";